var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment-timezone';
import { getAccountId } from '@ally/transfer-account-utils';
import { isSameDay, SERVER_TIMEZONE } from '@ally/date-utils';
export var REQUEST_DATE_FORMAT = 'YYYY-MM-DDT12:00:00Z';
function getAccount(account) {
    var numberPvtEncrypt = account.accountNumberPvtEncrypt, accountType = account.accountType, domain = account.domainDetails.domain;
    return {
        accountIdPvtEncrypt: getAccountId(account),
        accountType: accountType,
        domain: domain,
        numberPvtEncrypt: numberPvtEncrypt,
    };
}
function getPlan(transfer) {
    var deliveryDate = transfer.deliveryDate, transferSpeed = transfer.transferSpeed;
    var isImmediate = isSameDay(transfer.deliveryDate, moment.tz(SERVER_TIMEZONE));
    return __assign({ transferSpeed: transferSpeed === 'Next Day' ? 'NEXT_DAY' : 'STANDARD' }, (!isImmediate
        ? {
            startDate: moment(deliveryDate.toArray().slice(0, 3)).format(REQUEST_DATE_FORMAT),
        }
        : {}));
}
export var EMPTY_WITHHOLDING_ERROR = 'Transfer has a distribution type, but does not have federal/state withholding defined';
export var getUnknownTypeError = function (type) {
    return "Unknown type for withholding: ".concat(type);
};
export var getWithholding = function (type, value) {
    if (type === undefined || value === undefined || value === null) {
        throw new Error(EMPTY_WITHHOLDING_ERROR);
    }
    if (type === 'Dollar amount') {
        return { taxWithholdingType: 'FIXED', value: value };
    }
    if (type === 'Percent') {
        return { taxWithholdingType: 'PERCENTAGE', value: "".concat(value) };
    }
    throw new Error(getUnknownTypeError(type));
};
var distributionTypeMap = {
    Qualified: 'NORMAL',
    Premature: 'PREMATURE',
};
export var getIraDetail = function (transfer) {
    if (!transfer.distributionType)
        return undefined;
    var distributionType = transfer.distributionType, federalWithholdingType = transfer.federalWithholdingType, federalWithholdingValue = transfer.federalWithholdingValue, stateWithholdingType = transfer.stateWithholdingType, stateWithholdingValue = transfer.stateWithholdingValue;
    return {
        iraDetail: {
            distributionReason: distributionTypeMap[distributionType],
            distributionWithholding: {
                federalTaxWithholding: getWithholding(federalWithholdingType, federalWithholdingValue),
                stateTaxWithholding: getWithholding(stateWithholdingType, stateWithholdingValue),
            },
        },
    };
};
function transferToRequest(transfer) {
    var _a;
    var noteToSelf = ((_a = transfer.noteToSelf) === null || _a === void 0 ? void 0 : _a.replace(/(\r\n|\n|\r)/gm, ' ')) || '';
    return __assign({ amountPvtEncrypt: "".concat(transfer.amount.toFixed(2)), comment: noteToSelf, from: getAccount(transfer.fromAccount), plan: getPlan(transfer), to: getAccount(transfer.toAccount) }, getIraDetail(transfer));
}
export default transferToRequest;
//# sourceMappingURL=transferToRequest.js.map